import React from "react";
import { AnimatePresence } from "framer-motion";

import { FileInput } from "./FileInput";
import { useResetBuildSession } from "@rapid/hooks/useResetBuildSession";

export const UploadVisualAreaContent = React.memo(() => {
    // Reset all build session state when entering the homepage
    // This ensures a clean slate when starting a new model build
    useResetBuildSession();

    return (
        <AnimatePresence mode="wait">
            <FileInput key="file-input" />
        </AnimatePresence>
    );
});
